export default {
  // data: function () {
  //   return {
  //     c2pItems: [
  //       {unit: "mg/ml", change: 0.1},
  //       {unit: "g/ml", change: 100},
  //     ],
  //   };
  // },
  methods: {
    concToPercent(strength) {
      if (strength.toLowerCase().includes("mg/ml")) {
        const matches = strength.matchAll(/([0-9.]+)[ ]?(mg\/ml)/gi);
        for (const match of matches) {
          // dealing with @#$&! floating point precision issues!
          let precision = match[1].includes(".")
            ? match[1].split(".")[1].length
            : 0;
          let newNum = (match[1] / 10).toFixed(precision + 1);
          strength = strength.replace(match[0], newNum + "%");
        }
      } else if (strength.toLowerCase().includes("g/ml")) {
        const matches = strength.matchAll(/([0-9.]+)[ ]?(g\/ml)/gi);
        for (const match of matches) {
          // dealing with @#$&! floating point precision issues!
          // let precision = match[1].includes(".")
          //   ? match[1].split(".")[1].length
          //   : 0;
          let newNum = match[1] * 100; //.toFixed(precision + 1);
          strength = strength.replace(match[0], newNum + "%");
        }
      }

      return strength;
    },
  },
};
